import { render, staticRenderFns } from "./ShippingAccount.vue?vue&type=template&id=3ebc3209&"
import script from "./ShippingAccount.vue?vue&type=script&lang=js&"
export * from "./ShippingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports